import { useCRUD } from 'lib/swr-crud';
import { getProductById } from './api';
import { makeProductCacheKey } from './utils';

const useProduct = (productId, options, shouldFetch = true) => {
  const { data, error, mutate, isValidating, isLoading } = useCRUD(
    makeProductCacheKey(productId),
    shouldFetch
      ? async () => {
          const { response, error } = await getProductById(productId);

          if (error) throw error;

          return response.data;
        }
      : null,
    options,
  );

  const product = data || null;

  return {
    product,
    error,
    mutate,
    isValidating,
    isLoading,
  };
};

export default useProduct;
